import { Component, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { cResourceclosings, resourceclosings } from 'src/types/resourceclosings';
import { resourceclosings_returndata } from 'src/types/resourceclosings_returndata';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { cResource } from 'src/types/resource';

@Component({
  selector: 'app-resclosingsedit',
  templateUrl: './resclosingsedit.component.html',
  styleUrls: ['./resclosingsedit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ResclosingseditComponent implements OnInit {
  ResourceID: string = localStorage.getItem("SmartResourceID")!;
  ResourceClosing: cResourceclosings;
  httpResponse: any;
  id: string;
  vcStartDate: Date;
  vcEndDate: Date;

  resourceNameValid: boolean = true;
  resourceStartDateValid: boolean = true;
  resourceEndDateValid: boolean = true;
  resourceDateLoginValid: boolean = true;
  resourceDaysValid: boolean = true;
  resourceChosenValid: boolean = true;

  resourceStartTimeHours: any[];
  resourceStartTimeMins: any[];

  resourceEndTimeHours: any[];
  resourceEndTimeMins: any[];
  
  resourceSelectedStartTimeHours: string;
  resourceSelectedStartTimeMins: string;

  resourceSelectedEndTimeHours: string;
  resourceSelectedEndTimeMins: string;
  
  pageReady: boolean = false;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  newStartDate: Date;
  newEndDate: Date;

  closedallday: boolean = false;

  VenueID: string = localStorage.getItem("SmartVenueID")!;

  ResourceList: any[] = [];
  chosenResource: cResource = new cResource();

  stateOptions = [
    {label: 'Yes', value: true},
    {label: 'No', value: false}
  ];

  dayOptions = [
    {label: 'Monday', value: 'monday'},
    {label: 'Tuesday', value: 'tuesday'},
    {label: 'Wednesday', value: 'wednesday'},
    {label: 'Thursday', value: 'thursday'},
    {label: 'Friday', value: 'friday'},
    {label: 'Saturday', value: 'saturday'},
    {label: 'Sunday', value: 'sunday'}
  ];

  selectedDays: string[] = [];

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService,private globalService: GlobalService, private host: ElementRef) { 
    this.ResourceClosing = {
      id: null,
      resourceclosingid: null,
      resourceid: null,
      name: "",
      resourcetoclose: null,
      disabled: false,
      venueid: this.VenueID,
      startdate: null,
      enddate: null,
      publicmessage: null,
      venuemessage: null,
      closingbasedonday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false
    }

    this.resourceStartTimeHours = [
      {name: '00', code: '00'},
      {name: '01', code: '01'},
      {name: '02', code: '02'},
      {name: '03', code: '03'},
      {name: '04', code: '04'},
      {name: '05', code: '05'},
      {name: '06', code: '06'},
      {name: '07', code: '07'},
      {name: '08', code: '08'},
      {name: '09', code: '09'},
      {name: '10', code: '10'},
      {name: '11', code: '11'},
      {name: '12', code: '12'},
      {name: '13', code: '13'},
      {name: '14', code: '14'},
      {name: '15', code: '15'},
      {name: '16', code: '16'},
      {name: '17', code: '17'},
      {name: '18', code: '18'},
      {name: '19', code: '19'},
      {name: '20', code: '20'},
      {name: '21', code: '21'},
      {name: '22', code: '22'},
      {name: '23', code: '23'}
      ];
   
    this.resourceStartTimeMins = [
        {name: '00', code: '00'},
        {name: '05', code: '05'},
        {name: '10', code: '10'},
        {name: '15', code: '15'},
        {name: '20', code: '20'},
        {name: '25', code: '25'},
        {name: '30', code: '30'},
        {name: '35', code: '35'},
        {name: '40', code: '40'},
        {name: '45', code: '45'},
        {name: '50', code: '50'},
        {name: '55', code: '55'},
      ];

  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("RESOURCECLOSINGS", user)){
          this.AccessAllowed = true;
          this.id = this.route.snapshot.paramMap.get('id');
          if(this.id != "0")
          {
            this.http.get(bmxurl + "resourcelist/" + this.VenueID).subscribe(response => {
              this.ResourceList = (response as any).data;
              this.pageReady = false;
              this.http.get(bmxurl + "ResourceClosing/" + this.VenueID + "/" + this.id).subscribe(response => {
                this.httpResponse = (response as resourceclosings_returndata)
                if (this.httpResponse.succeeded)
                {
                  this.ResourceClosing = new cResourceclosings();
                  this.ResourceClosing.resourceid = (this.httpResponse.data as cResourceclosings).resourceid;
                  this.ResourceClosing.id = (this.httpResponse.data as cResourceclosings).id;
                  this.ResourceClosing.resourceclosingid = (this.httpResponse.data as cResourceclosings).resourceclosingid;
                  this.ResourceClosing.name = (this.httpResponse.data as cResourceclosings).name;
                  this.ResourceClosing.resourcetoclose = (this.httpResponse.data as cResourceclosings).resourcetoclose;
                  this.ResourceClosing.disabled = (this.httpResponse.data as cResourceclosings).disabled;
                  this.ResourceClosing.venueid = (this.httpResponse.data as cResourceclosings).venueid;
                  this.ResourceClosing.startdate = (this.httpResponse.data as cResourceclosings).startdate;
                  this.ResourceClosing.enddate = (this.httpResponse.data as cResourceclosings).enddate;
                  this.ResourceClosing.publicmessage = (this.httpResponse.data as cResourceclosings).publicmessage;
                  this.ResourceClosing.venuemessage = (this.httpResponse.data as cResourceclosings).venuemessage;

                  this.ResourceClosing.closingbasedonday = (this.httpResponse.data as cResourceclosings).closingbasedonday;
                  this.ResourceClosing.monday = (this.httpResponse.data as cResourceclosings).monday;
                  this.ResourceClosing.tuesday = (this.httpResponse.data as cResourceclosings).tuesday;
                  this.ResourceClosing.wednesday = (this.httpResponse.data as cResourceclosings).wednesday;
                  this.ResourceClosing.thursday = (this.httpResponse.data as cResourceclosings).thursday;
                  this.ResourceClosing.friday = (this.httpResponse.data as cResourceclosings).friday;
                  this.ResourceClosing.saturday = (this.httpResponse.data as cResourceclosings).saturday;
                  this.ResourceClosing.sunday = (this.httpResponse.data as cResourceclosings).sunday;

                  this.syncSelectedDaysFromModel();

                  this.getChosenResource();
                  
                  this.newStartDate = new Date(Number(this.ResourceClosing.startdate.substring(0,4)), Number(this.ResourceClosing.startdate.substring(5,7)) - 1, Number(this.ResourceClosing.startdate.substring(8,10)));
                  this.newEndDate = new Date(Number(this.ResourceClosing.enddate.substring(0,4)), Number(this.ResourceClosing.enddate.substring(5,7)) - 1, Number(this.ResourceClosing.enddate.substring(8,10)));

                  this.resourceSelectedStartTimeHours = this.ResourceClosing.startdate.substring(11,13);
                  this.resourceSelectedStartTimeMins = this.ResourceClosing.startdate.substring(14,16);
          
                  this.resourceSelectedEndTimeHours = this.ResourceClosing.enddate.substring(11,13);
                  this.resourceSelectedEndTimeMins = this.ResourceClosing.enddate.substring(14,16);
        
                  this.pageReady = true;
                }
                else
                {
                  this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Resource Closings'});
                  this.pageReady = false;
                }
              }, error => {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Resource Closings, error:' + error.messages[0]});
                this.pageReady = false;
              });
            });
          }
          else
          {
            this.http.get(bmxurl + "resourcelist/" + this.VenueID).subscribe(response => {
              if((response as any).succeeded)
              {
                this.ResourceList = (response as any).data;
              } 
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Resources'});
                this.pageReady = false;
              }
              }, error => {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Resources, error:' + error.messages[0]});
                this.pageReady = false;
              });
            
            this.pageReady = true;
          }
        }

        this.CompletedLoading = true;


      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  getChosenResource()
  {
    this.ResourceList.forEach(element => {
      if(element.id == this.ResourceClosing.resourcetoclose.id)
      {
        this.chosenResource = element;
      }
    });
  }

  syncSelectedDaysFromModel()
  {
    this.selectedDays = [];

    if(this.ResourceClosing.monday) this.selectedDays.push('monday');
    if(this.ResourceClosing.tuesday) this.selectedDays.push('tuesday');
    if(this.ResourceClosing.wednesday) this.selectedDays.push('wednesday');
    if(this.ResourceClosing.thursday) this.selectedDays.push('thursday');
    if(this.ResourceClosing.friday) this.selectedDays.push('friday');
    if(this.ResourceClosing.saturday) this.selectedDays.push('saturday');
    if(this.ResourceClosing.sunday) this.selectedDays.push('sunday');
  }

  onDaysChange()
  {
    this.ResourceClosing.monday = this.selectedDays.includes('monday');
    this.ResourceClosing.tuesday = this.selectedDays.includes('tuesday');
    this.ResourceClosing.wednesday = this.selectedDays.includes('wednesday');
    this.ResourceClosing.thursday = this.selectedDays.includes('thursday');
    this.ResourceClosing.friday = this.selectedDays.includes('friday');
    this.ResourceClosing.saturday = this.selectedDays.includes('saturday');
    this.ResourceClosing.sunday = this.selectedDays.includes('sunday');

    this.DoValidCheck();
  }

  toggleDay(day: string)
  {
    const index = this.selectedDays.indexOf(day);

    if(index > -1)
    {
      this.selectedDays.splice(index, 1);
    }
    else
    {
      this.selectedDays.push(day);
    }

    this.onDaysChange();
  }

  updateData()
  {
    if ([this.DoDateValidCheck(), this.DoValidCheck(), this.DoDateCheck()].every(x => x == true))
    {
      this.ResourceClosing.resourcetoclose = this.chosenResource;
      this.ResourceClosing.resourceid = this.chosenResource.resourceId;

      if(this.id=="0")
      {
        this.http.post<resourceclosings>(bmxurl + "/ResourceClosing", this.ResourceClosing).subscribe(response => {
          this.httpResponse = response
          if(this.httpResponse.succeeded == true)
          {
            this.messageService.add({severity:'success', summary:'Saved', detail:'Resource Closing successfully created'});
            this.router.navigateByUrl("/resourceclosings");
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages[0]});
        })
      }
      else
      {
        this.ResourceClosing.disabled = false;
        
        this.http.put<resourceclosings>(bmxurl + "/ResourceClosing", this.ResourceClosing).subscribe(response => {
          this.httpResponse = response
          if(this.httpResponse.succeeded == true)
          {
            this.messageService.add({severity:'success', summary:'Saved', detail:'Resource Closing successfully updated'});
            this.router.navigateByUrl("/resourceclosings");
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
        })
      }
    }
    else
    {
      this.showFirstProblem();
    }
  }

  //A failed save says why next to the field, but the field can be off the bottom of the screen -
  //the resource dropdown usually is - so the page is scrolled to the first message. Waits a
  //tick so a message the save has only just turned on is there to scroll to.
  private showFirstProblem() {
    setTimeout(() => {
      const first = (this.host.nativeElement as HTMLElement).querySelector(".text-danger") as HTMLElement;

      if (first == null) {
        return;
      }

      const field = (first.closest(".field") as HTMLElement) ?? first;

      field.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  DoDateCheck()
  {
    let AllValid = true;

    //A day based closing used to be stamped with 1900-3000 placeholder dates on the
    //assumption that dates and times did not apply to it. They do - the days say which days
    //the closing lands on, the dates and times say over what period and between what hours -
    //so the entered values are now kept for both kinds of closing.

     let startdatestring = "";

    startdatestring = this.stringifyDate(new Date(this.newStartDate).getFullYear(), new Date(this.newStartDate).getMonth(), new Date(this.newStartDate).getDate(), Number(this.resourceSelectedStartTimeHours), Number(this.resourceSelectedStartTimeMins));

    this.ResourceClosing.startdate = startdatestring;

     let enddatestring = "";

     enddatestring = this.stringifyDate(new Date(this.newEndDate).getFullYear(), new Date(this.newEndDate).getMonth(), new Date(this.newEndDate).getDate(), Number(this.resourceSelectedEndTimeHours), Number(this.resourceSelectedEndTimeMins));

    this.ResourceClosing.enddate = enddatestring;

    if(this.ResourceClosing.startdate > this.ResourceClosing.enddate)
    {
      AllValid = false;
      this.resourceDateLoginValid = false;
    }
    else
    {
      this.resourceDateLoginValid = true;
    }

    return AllValid
  }

  stringifyDate(Year: number, Month: number, Day: number, Hour: number, Mins: number): string
  {
    let returnString = "";

    returnString = Year + "-" +  ('00' + (Month + 1).toString()).slice(-2) + "-" +  ('00' + Day.toString()).slice(-2)+ "T" + ('00' + Hour.toString()).slice(-2) + ":" + ('00' + Mins.toString()).slice(-2) + ":00.0000Z";

    return returnString;
  }

  DoValidCheck()
  {
    let AllValid = true;

    if(this.ResourceClosing.name == null || this.ResourceClosing.name == "")
    {
      AllValid = false;
      this.resourceNameValid = false;
    }
    else
    {
      this.resourceNameValid = true;
    }

    //A closing has to close something. chosenResource starts as an empty resource rather than
    //null, so it is the id that says whether one has really been picked.
    if(this.chosenResource == null || this.chosenResource.resourceId == null || this.chosenResource.resourceId == "")
    {
      AllValid = false;
      this.resourceChosenValid = false;
    }
    else
    {
      this.resourceChosenValid = true;
    }

    if(this.ResourceClosing.closingbasedonday && this.selectedDays.length == 0)
    {
      AllValid = false;
      this.resourceDaysValid = false;
    }
    else
    {
      this.resourceDaysValid = true;
    }

    return AllValid;
  }

  DoDateValidCheck()
  {
    let AllValid = true;

    //Dates are required for a day based closing too, now that they are asked for.
    if(this.ResourceClosing.startdate == null)
    {
      AllValid = false;
      this.resourceStartDateValid = false;
    }
    else
    {
      this.resourceStartDateValid = true;
    }

    if(this.ResourceClosing.enddate == null)
    {
      AllValid = false;
      this.resourceEndDateValid = false;
    }
    else
    {
      this.resourceEndDateValid = true;
    }

    return AllValid;
  }

  returnToList()
  {
    this.router.navigateByUrl("/resourceclosings");
  }
}